import axios from "utils/axios";
import { stringify } from "query-string";

export const getAuditLog = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/logs/pagination?${query}`);
};
